<template>
  <div
    class="tasklist-page-header d-flex flex-column"
    data-testid="tasklist__header-bar"
  >
    <!-- <div class="" data-testid="tasklist__breadcrumbs-group">
      <lb-breadcrumbs :items="breadcrumbs" />
    </div> -->

    <TaskPageHeader
      :title="title"
      :metadata="metadata"
      :show-noa="showNoa"
      :activity-log-type="activityLogType"
      :export-disabled="exportDisabled"
      :load-progress="loadProgress"
      @refresh="$emit('refresh')"
      @retry-load="$emit('retry-load')"
      @noa="$emit('noa')"
      @export="$emit('export')"
      @status-report="onStatusReport"
      data-testid="tasklist__header"
    >
      <template #actions>
        <BulkUpload
          v-if="canImport"
          :upload-type="$options.BULK_CHECKLIST_UPLOAD_TYPE.CHECKLIST"
          test-id-prefix="tasklist-upload"
          button-label="Import Tasks"
          :expected-headings="expectedHeaders"
          :custom-columns="customColumns"
          :project="projectId"
          @reload="$emit('reload')"
          data-testid="tasklist__import-btn"
        />

        <TasklistAddTask
          v-if="canAddTask"
          ref="tasklistAddTask"
          button-label="New Task"
          :project-id="projectId"
          :custom-columns="customColumns"
          :category-acc="categoryAcc"
          :subcategory-acc="subcategoryAcc"
          :coa-category-acc="coaCategoryAcc"
          :coa-subcategory-acc="coaSubcategoryAcc"
          :user-details="userDetails"
          @reload="$emit('reload')"
        />
      </template>
    </TaskPageHeader>
  </div>
</template>

<script>
import TaskPageHeader from "./components/TaskPageHeader/TaskPageHeader.vue";

import BulkUpload from "../../../components/BulkUpload/BulkUpload.vue";

import TasklistAddTask from "./TasklistAddTask.vue";
import { BULK_CHECKLIST_UPLOAD_TYPE } from "../../../utils/constants";

export default {
  name: "TasklistPageHeader",

  BULK_CHECKLIST_UPLOAD_TYPE,

  components: {
    TaskPageHeader,

    BulkUpload,

    TasklistAddTask,
  },

  props: {
    title: {
      type: String,

      default: "Tasks",
    },

    exportDisabled: {
      type: Boolean,

      default: false,
    },

    loadProgress: {
      type: Object,

      default: null,
    },

    breadcrumbs: {
      type: Array,

      default: () => [],
    },

    metadata: {
      type: Object,

      default: () => ({}),
    },

    showNoa: {
      type: Boolean,

      default: false,
    },

    activityLogType: {
      type: [Array, String],

      default: () => [],
    },

    canImport: {
      type: Boolean,

      default: false,
    },

    canAddTask: {
      type: Boolean,

      default: false,
    },

    expectedHeaders: {
      type: Array,

      default: () => [],
    },

    customColumns: {
      type: Array,

      default: () => [],
    },

    chartOfAccounts: {
      type: Array,

      default: () => [],
    },

    projectId: {
      type: String,

      default: "",
    },

    activeUsers: {
      type: Array,

      default: () => [],
    },

    locationList: {
      type: Array,

      default: () => [],
    },

    categoryAcc: {
      type: Array,

      default: () => [],
    },

    subcategoryAcc: {
      type: Array,

      default: () => [],
    },

    coaCategoryAcc: {
      type: Array,

      default: () => [],
    },

    coaSubcategoryAcc: {
      type: Array,

      default: () => [],
    },

    userDetails: {
      type: Object,

      default: () => ({ activeUsers: [], activeUserIds: [] }),
    },
  },

  methods: {
    openTaskForEdit(task) {
      this.$refs.tasklistAddTask?.openForEdit(task);
    },

    onStatusReport() {
      this.$emit("status-report");
    },
  },
};
</script>
